import { Trans } from '@lingui/macro'
import { MenuItem } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

import { useDownloadConsent } from '../../model/useDownloadConsent'

type DownloadConsentProps = {
  onClose?: () => void
  patientId: string
}

export function DownloadConsent({ patientId, onClose }: DownloadConsentProps) {
  const isLargeScreen = useIsLargeScreen()

  const { downloadConsent, isDownloadingConsent } = useDownloadConsent(patientId)

  if (isLargeScreen) {
    return (
      <LoadingButton
        id="consent"
        disableElevation
        loading={isDownloadingConsent}
        onClick={downloadConsent}
        startIcon={<DownloadRoundedIcon />}
        variant="contained"
      >
        <Trans>Download consent</Trans>
      </LoadingButton>
    )
  }

  return (
    <MenuItem
      onClick={() => {
        downloadConsent()
        onClose?.()
      }}
      disableRipple
    >
      <DownloadRoundedIcon />
      <Trans>Download consent</Trans>
    </MenuItem>
  )
}
